// import React, { useMemo, useRef, useState } from "react";
// import { Button, Modal } from "react-bootstrap";
// import * as XLSX from "xlsx";

// const GroupTable = ({ Group, title, itemDetails }) => {
//   const tableRef = useRef(null);

//   const [showModal, setShowModal] = useState(false);
//   const [selectedGroup, setSelectedGroup] = useState(null);

//   const openGroupModal = (groupName) => {
//     const normalizedKey = normalize(groupName);
//     setSelectedGroup(normalizedKey);
//     setShowModal(true);
//   };

//   const closeModal = () => setShowModal(false);

//   const normalize = (str) =>
//     (str || "")
//       .toLowerCase()
//       .replace(/\s+/g, "");

//   const groupedMap = useMemo(() => {
//     const map = {};

//     (itemDetails || []).forEach(item => {
//       const key = normalize(item.Description);

//       if (!map[key]) map[key] = [];
//       map[key].push(item);
//     });

//     return map;
//   }, [itemDetails]);

//   const handleExport = () => {
//     if (!tableRef.current) return;

//     const ws = XLSX.utils.table_to_sheet(tableRef.current.querySelector("table"));
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, title);

//     XLSX.writeFile(wb, `${title}_table.xlsx`);
//   };

//   const modalRows = selectedGroup ? groupedMap[selectedGroup] || [] : [];

//   return (
//     <>
//       <div className="food-column-group">
//         <div className="table-responsive-food-header">
//           <div className="bg-heading-food">
//             <h4 className="food-heading">{title}</h4>
//           </div>
//           {/* ✅ replaced DownloadTableExcel */}
//           <button className="export" onClick={handleExport}>
//             Export
//           </button>
//         </div>
//         <div className="row food-table-group-row" ref={tableRef}>
//           <table className="table-group">
//             <thead>
//               <tr>
//                 <th>Group:</th>
//                 <th>Total:</th>
//               </tr>
//             </thead>
//             <tbody>
//               {!Group?.error &&
//                 Group.map((food, index) => (
//                   <tr
//                     key={index}
//                     className="cursor-pointer hover:bg-gray-100"
//                     onClick={() => openGroupModal(food.groupName)}
//                   >
//                     <td>{food.groupName}</td>
//                     <td>{food.groupTotal}</td>
//                   </tr>
//                 ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <Modal show={showModal} onHide={closeModal} size="lg" centered>
//         <Modal.Header closeButton>
//           <Modal.Title>
//             {modalRows[0]?.Description || selectedGroup}
//           </Modal.Title>

//         </Modal.Header>

//         <Modal.Body>
//           <div className="modal-table-container">
//             <table className="modal-table">
//               <thead>
//                 <tr>
//                   <th>Item</th>
//                   <th>Rate</th>
//                   <th>Qty</th>
//                   <th>Total</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {modalRows.length > 0 ? (
//                   [...modalRows] 
//                     .sort((a, b) => b.quantity - a.quantity) 
//                     .map((row, i) => (
//                       <tr key={i}>
//                         <td>{row.itemName}</td>
//                         <td>{row.itemrate}</td>
//                         <td>{row.quantity}</td>
//                         <td>{row.total}</td>
//                       </tr>
//                     ))
//                 ) : (
//                   <tr>
//                     <td colSpan="5">No data</td>
//                   </tr>
//                 )}
//               </tbody>

//               <tfoot>
//                 <tr>
//                   <td colSpan="3"><strong>Total</strong></td>
//                   <td>
//                     {modalRows
//                       .reduce((sum, r) => sum + Number(r.total), 0)
//                       .toFixed(2)}
//                   </td>
//                 </tr>
//               </tfoot>
//             </table>
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button variant="secondary" onClick={closeModal}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default GroupTable;












/* Complementary */

import React, { useMemo, useRef, useState } from "react";
import * as XLSX from "xlsx";
import { formatSalesValue } from "../../../utils/formatUtils";
import { IoClose } from "react-icons/io5";

const GroupTable = ({
  Group,
  title,
  itemDetails,
  excludeComplementary,
  onlyComplementary,
  summaryQuantity,
  summaryTotal,
}) => {
  const tableRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);

  const normalize = (str) => (str || "").toLowerCase().replace(/\s+/g, "");

  const openGroupModal = (groupName) => {
    const normalizedKey = normalize(groupName);
    setSelectedGroup(normalizedKey);
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  // Group items by Description
  const groupedMap = useMemo(() => {
    const map = {};

    (itemDetails || []).forEach((item) => {
      const key = normalize(item.Description);

      if (!map[key]) map[key] = [];
      map[key].push(item);
    });

    return map;
  }, [itemDetails]);

  // Unified helper: resolves group total based on active filter flags
  const resolveGroupTotal = (group) =>
    onlyComplementary
      ? Number(group.complementaryGroupTotal || 0)
      : excludeComplementary
        ? Number(group.groupTotal || 0)
        : Number(group.groupTotal || 0) +
        Number(group.complementaryGroupTotal || 0);

  const resolveGroupQuantity = (group) =>
    onlyComplementary
      ? Number(group.complementaryGroupQty || 0)
      : excludeComplementary
        ? Number(group.qty || 0)
        : Number(group.qty || 0) +
        Number(group.complementaryGroupQty || 0);

  const handleExport = () => {
    if (!Group || Group.length === 0) return;

    const data = [["Group", "Total"]];

    let grandTotal = 0;

    const visibleGroups = onlyComplementary
      ? Group.filter((g) => g.hasComplementary)
      : Group;

    visibleGroups.forEach((group) => {
      const total = resolveGroupTotal(group);
      grandTotal += total;
      data.push([group.groupName, total.toFixed(2)]);
    });

    data.push([]);
    data.push(["Total", grandTotal.toFixed(2)]);

    const ws = XLSX.utils.aoa_to_sheet(data);

    ws["!cols"] = [{ wch: 25 }, { wch: 15 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, title);

    XLSX.writeFile(wb, `${title}_table.xlsx`);
  };

  const modalRows = useMemo(() => {
    if (!selectedGroup) return [];

    const rows = groupedMap[selectedGroup] || [];

    if (onlyComplementary) {
      return rows.filter((row) => row.hasComplementary);
    }

    return rows;
  }, [selectedGroup, groupedMap, onlyComplementary]);

  // Resolve per-item quantity/total for the modal
  const resolveItemQuantity = (row) =>
    onlyComplementary
      ? Number(row.complementaryQuantity || 0)
      : excludeComplementary
        ? Number(row.quantity || 0)
        : Number(row.quantity || 0) + Number(row.complementaryQuantity || 0);

  const resolveItemTotal = (row) =>
    onlyComplementary
      ? Number(row.complementaryTotal || 0)
      : excludeComplementary
        ? Number(row.total || 0)
        : Number(row.total || 0) + Number(row.complementaryTotal || 0);

  const visibleGroups = onlyComplementary
    ? (Group || []).filter((g) => g.hasComplementary)
    : Group || [];

  // Check if any group has a non-zero quantity — hide column if all are 0
  const hasQtyData = visibleGroups.some((g) => resolveGroupQuantity(g) > 0);

  // Check if any modal row has a non-zero quantity — hide column if all are 0
  const hasModalQtyData = modalRows.some((r) => resolveItemQuantity(r) > 0);

  return (
    <>
      <div className="w-full">
        <div className="mb-2 flex items-center justify-between">
          <div className="text-base font-semibold text-gray-900">
            {title} Group
          </div>

          <button
            onClick={handleExport}
            className="rounded-lg bg-gray-100 px-3 py-1.5 text-sm font-medium text-gray-700 transition hover:bg-gray-200"
          >
            Export
          </button>
        </div>

        <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
          <div className="overflow-auto max-h-[600px] tiny-scrollbar" ref={tableRef}>
            <table className="min-w-full border-collapse text-sm text-center">
              <thead className="sticky top-0 z-10 bg-gray-100">
                <tr className="border-b border-gray-200">
                  <th className="p-2 text-xs font-semibold uppercase tracking-wider text-gray-600">
                    Group
                  </th>
                  {hasQtyData && (
                    <th className="p-2 text-xs font-semibold uppercase tracking-wider text-gray-600">
                      Quantity
                    </th>
                  )}
                  <th className="p-2 text-xs font-semibold uppercase tracking-wider text-gray-600">
                    Total
                  </th>
                </tr>
              </thead>

              <tbody>
                {!Group?.error &&
                  visibleGroups.map((group, index) => {
                    const total = resolveGroupTotal(group);
                    const qty = resolveGroupQuantity(group);

                    return (
                      <tr
                        key={index}
                        className="cursor-pointer border-b border-gray-100 transition-colors hover:bg-gray-50"
                        onClick={() => openGroupModal(group.groupName)}
                      >
                        <td className="px-2 py-1.5 font-medium text-gray-700">
                          {group.groupName}
                        </td>

                        {hasQtyData && (
                          <td className="px-2 py-1.5 font-medium text-gray-800">
                            {qty}
                          </td>
                        )}

                        <td className="px-2 py-1.5 font-semibold text-gray-800">
                          {formatSalesValue(total)}
                        </td>
                      </tr>
                    );
                  })}

                {!Group?.error && visibleGroups.length === 0 && (
                  <tr>
                    <td
                      colSpan={hasQtyData ? 3 : 2}
                      className="py-6 text-center text-sm text-gray-500"
                    >
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>

              {!Group?.error && visibleGroups.length > 0 && (
                <tfoot className="sticky bottom-0 bg-gray-100 border-t border-gray-300">
                  <tr>
                    <td className="p-2 font-semibold text-gray-900">
                      Total
                    </td>
                    {hasQtyData && (
                      <td className="p-2 font-semibold text-gray-900">
                        {summaryQuantity}
                      </td>
                    )}
                    <td className="p-2 font-semibold text-gray-900">
                      {formatSalesValue(summaryTotal)}
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
      </div>

      {/* MODAL */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm">
          <div className="flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-lg bg-white shadow-2xl">

            {/* Header */}
            <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3">
              <div className="text-lg font-semibold text-gray-900">
                {modalRows[0]?.Description || selectedGroup}
              </div>
              <button
                onClick={closeModal}
                className="rounded-lg p-1.5 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700"
              >
                <IoClose className="h-5 w-5" />
              </button>
            </div>

            {/* Body */}
            <div className="flex-1 overflow-auto rounded-lg border border-gray-200 tiny-scrollbar px-4 py-3">
              <table className="min-w-full border-collapse text-sm text-center">
                <thead className="sticky top-0 z-10 bg-gray-100">
                  <tr className="border-b border-gray-200">
                    <th className="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-gray-600">Item</th>
                    <th className="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-gray-600">Rate</th>
                    {hasModalQtyData && (
                      <th className="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-gray-600">Qty</th>
                    )}
                    <th className="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-gray-600">Total</th>
                  </tr>
                </thead>

                <tbody>
                  {modalRows.length > 0 ? (
                    [...modalRows]
                      .sort((a, b) => resolveItemQuantity(b) - resolveItemQuantity(a))
                      .map((row, i) => {
                        const quantity = resolveItemQuantity(row);
                        const total = resolveItemTotal(row);
                        return (
                          <tr key={i} className="border-b border-gray-100 hover:bg-gray-50">
                            <td className="px-3 py-1.5 text-gray-700">{row.itemName}</td>
                            <td className="px-3 py-1.5 text-gray-700">{formatSalesValue(row.itemrate)}</td>
                            {hasModalQtyData && (
                              <td className="px-3 py-1.5 font-medium text-gray-900">{quantity}</td>
                            )}
                            <td className="px-3 py-1.5 font-semibold text-gray-900">{formatSalesValue(total)}</td>
                          </tr>
                        );
                      })
                  ) : (
                    <tr>
                      <td colSpan={hasModalQtyData ? 4 : 3} className="py-6 text-center text-sm text-gray-500">
                        No data
                      </td>
                    </tr>
                  )}
                </tbody>

                <tfoot className="sticky bottom-0 bg-gray-100">
                  <tr className="border-t border-gray-200">
                    <td colSpan={hasModalQtyData ? 2 : 1}></td>
                    {hasModalQtyData && (
                      <td className="px-3 py-1.5 font-semibold text-gray-900">
                        {modalRows.reduce((sum, r) => sum + resolveItemQuantity(r), 0)}
                      </td>
                    )}
                    <td className="px-3 py-1.5 font-semibold text-gray-900">
                      {formatSalesValue(modalRows.reduce((sum, r) => sum + resolveItemTotal(r), 0))}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {/* Footer */}
            <div className="flex justify-end border-t border-gray-200 px-4 py-3">
              <button
                onClick={closeModal}
                className="rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-200"
              >
                Close
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default GroupTable;